<div class="d-flex flex-column justify-content-center align-items-center thanks-container">
  @if(!model().requestSucceeded()) {
    @if(orderedDirectly()) {
      <h3>{{ 'orderChoice.configuration-consistent_sample.error.title' | translate }}</h3>
      <p> {{ 'orderChoice.configuration-consistent_sample.error.message' | translate }} </p>
    } @else {
      <h3>{{ 'requestFinalization.title.finalizationError' | translate }}</h3>
      <p> {{ 'requestFinalization.message.finalizationError' | translate }} </p>
    }
  } @else {
    @if(orderedDirectly()) {
      <h3 data-testid="thank-you-order">{{ 'orderMultiple.thanks.thank_you' | translate}}</h3>
      <p> <app-svg-icon type="email" [inline]="true"/> {{ 'orderMultiple.thanks.mail_notice' | translate}}</p>
    } @else {
      <h3 data-testid="thank-you-request">{{ 'requestFinalization.title.finalizationSuccess' | translate}}</h3>
      <p class="text-center"><app-svg-icon type="email" [inline]="true"/><span [innerHTML]="'requestFinalization.message.finalizationSuccess_no_article_number' | translate"></span></p>
    }
  }
</div>
